var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"boss-layout-block boss-message-mail-body pega-pre-wrap",domProps:{"innerHTML":_vm._s(_vm.$sanitize(_vm.renderBody))}})}
var staticRenderFns = []

export { render, staticRenderFns }